module.exports = __webpack_public_path__ + "media/images/endcall-c744b0f3b3cfecd223df4475f928c1b1.png";